import { render, staticRenderFns } from "./TokenizedTranscriptionContent.vue?vue&type=template&id=7c14e2e3"
import script from "./TokenizedTranscriptionContent.vue?vue&type=script&lang=js"
export * from "./TokenizedTranscriptionContent.vue?vue&type=script&lang=js"
import style0 from "./TokenizedTranscriptionContent.vue?vue&type=style&index=0&id=7c14e2e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports